module.exports = "\n<div ng-include=\"'accordion-template.html'\" ng-if=\"Ctrl.occurrence.typefield == 'accordion'\"></div>\n<div ng-include=\"'panel-template.html'\" ng-if=\"Ctrl.occurrence.typefield == 'panel'\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/occurrence/templates/main-template.html
// module id = 291
// module chunks = 0